// Functions for determining language options
export default { 
  name: "language",
  methods: {
    // Search through array for specified language and return value
    returnValueInLanguage: function(lang, array) {
      // Save index of English
      let enIndex;
      // Return null if null
      if (!array) {
        return null;
      }
      // Return null if array is empty
      if (array.length === 0) {
        return null;
      } else {
        for (let i = 0; i < array.length; i++) {
          if (array[i].langId === lang) {
            return array[i];
          }
          // Saves index if provided language is not found
          if (array[i].langId === "en") {
            enIndex = i;
          }
        }
        // Return English index if provided language is not found
        return array[enIndex];
      }
    },
    // Data is what to search through to get list
    // Language and list are strings to match property in component
    getLanguages: function(data, language, list) {
      // Get all language options available for descriptions
      this[list] = [];
      for (let i = 0; i < data.length; i++) {
        this[list].push(data[i].langId);
      }
      if (this[list].length === 0) {
        this[language] = "";
      // If there is only one language available, set currentLanguage to it
      } else if (this[list].length === 1) {
        this[language] = this[list][0];
      } else if (this[list].length > 1) {
        // Check for existence of English text
        if (this[list].indexOf("en") !== -1) {
          this[language] = "en";
        // If there is no English available, set to first language
        } else {
          this[language] = this[list][0];
        }
      }
    },
    getLanguageList: function(array, data) {
      let languages = [];
      for (let i = 0; i < array.length; i++) {
        languages.push(array[i].langId);
      }
      this[data] = languages;
    },
    setLanguage: function(array, data) {
      let language = false;
      let english = false;
      // Check to see if current language is available
      for (let i = 0; i < array.length; i++) {
        // if (array[i] === this.defaultLanguage) {
        if (array[i] === this[data]) {
          language = true;
          break;
        }
      }
      // If language is true, no change required, exit
      if (language) {
        return;
      // If previously selected language is not available, 
      // find English or first available language
      } else {
        for (let i = 0; i < array.length; i++) {
          // If English is available, set default
          if (array[i] === "en") {
            english = true;
            this[data] = "en";
            break;
          }
        }
        // Otherwise, set to first available language
        if (!english) {
          // this[data] = array[0].langId;
          this[data] = array[0];
        }
      }
    },
  },
}